module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/EMPIRE_01.a418de4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/EMPIRE_01.jpg
// module id = ksSY
// module chunks = 0